import { useQuery } from "@apollo/client";
import { GET_STORIES, GET_STORY } from "../graphql/stories";
import type { Story } from "../types/models";

interface StoriesData {
  stories: Story[];
}

interface StoriesVariables {
  limit?: number;
  page?: number;
  latestOnly?: boolean;
}

interface StoryData {
  story: Story | null;
}

interface StoryVariables {
  id: string;
}

// useStories hook - Accept limit, page, latestOnly parameters
export const useStories = ({
  latestOnly = false,
  limit = 6,
  page = 1,
}: {
  latestOnly?: boolean;
  limit?: number;
  page?: number;
} = {}) => {
  const { data, loading, error } = useQuery<StoriesData, StoriesVariables>(
    GET_STORIES,
    {
      variables: { latestOnly, limit, page },
    }
  );

  // Filter out deleted stories as a defensive measure (backend should already filter)
  const stories = (data?.stories || []).filter(
    (story) => story.isDeleted !== true
  );

  return {
    data: stories,
    isLoading: loading,
    error,
  };
};

// useStory hook - Accept id parameter
export const useStory = (id: string | undefined) => {
  const { data, loading, error } = useQuery<StoryData, StoryVariables>(
    GET_STORY,
    {
      variables: id ? { id } : { id: "" },
      skip: !id,
    }
  );

  return {
    story: data?.story || null,
    isLoading: loading,
    error,
  };
};

